/* global gdAlertify */
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axiosInstance from '../config/axiosConfig';
import BuscarPaciente from './components/BuscarPaciente';
import BuscarAuxiliar from './components/BuscarAuxiliar';
import Select from 'react-select';
import { calculateAge, formatFechaES } from '../utils/utils';

const FormVisita = () => {
    const { id } = useParams();
    const [formData, setFormData] = useState({
        visitaID: 0,
        pacienteID: '',
        fechaVisita: '',
        tipoVisita: '',
        diagnostico: '',
        estado_salud: '',
        estado_cognitivo: '',
        habla: '',
        movimiento: '',
        antecedentes_medicos: '',
        examen_fisico: '',
        medicamento_horarios: '',
        rutina: '',
        plan_atencion: '',
        observaciones_paciente: '',
        visita_fuera_santiago: 0,
    });

    const [pacienteInfo, setPacienteInfo] = useState(null);
    const [auxiliares, setAuxiliares] = useState([]);
    const [auxiliarInfo, setAuxiliarInfo] = useState(null);
    const [auxiliarOption, setAuxiliarOption] = useState(null);
    const [observacionesList, setObservacionesList] = useState([]);
    const [tipoVisita, setTipoVisita] = useState([{ value: 1, label: "Presencial" }, { value: 3, label: "Presencial Fuera de Santiago" }, { value: 2, label: "Telefonico" }]);

    useEffect(() => {
        if (id && id != undefined) {
            fetchVisita(id);
        }
    }, [id]);

    const fetchVisita = async (visitaId) => {
        try {
            gdAlertify.showLoader();
            const { data } = await axiosInstance.post(`/paciente/ver-visita`,
                {visitaID:visitaId}
            );

            const visita = data.data;
            console.log(data);
            setFormData({
                    visitaID: (id && id != undefined) ? visita.visitaID || 0 : 0,
                    pacienteID: visita.pacienteID || '',
                    fechaVisita: visita.fecha_visita || '',
                    tipoVisita: visita.tipo_visita || '',
                    diagnostico: visita.diagnostico || '',
                    estado_salud: visita.estado_salud || '',
                    estado_cognitivo: visita.estado_cognitivo || '',
                    habla: visita.habla || '',
                    movimiento: visita.movimiento || '',
                    antecedentes_medicos: visita.antecedentes_medicos || '',
                    examen_fisico: visita.examen_fisico || '',
                    medicamento_horarios: visita.medicamento_horarios || '',
                    rutina: visita.rutina || '',
                    plan_atencion: visita.plan_atencion || '',
                    observaciones_paciente: visita.observacion || '', // <- campo en SQL se llama `observacion`
                    visita_fuera_santiago: visita.visita_fuera_santiago || '',
                });
                setObservacionesList(visita.observaciones || []);

            // Para mostrar paciente y auxiliares si están incluidos
            if (visita.paciente) {
                setPacienteInfo(visita.paciente);
                setAuxiliares((visita.paciente.auxiliares || []).map(aux => ({
                    value: aux.id,
                    label: `${aux.nombre} ${aux.apellidoPaterno} ${aux.apellidoMaterno} (${aux.rut})`
                })));
            }

            // Si venía auxiliar por defecto seleccionado
            if (data.auxiliar) {
                setAuxiliarInfo({
                    auxiliarID: data.auxiliar.id,
                    nombre: `${data.auxiliar.nombre} ${data.auxiliar.apellidoPaterno} ${data.auxiliar.apellidoMaterno}`
                });
            }

        } catch (error) {
            gdAlertify.alertError("Error al cargar la visita.");
        } finally {
            gdAlertify.hideLoader();
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSelect = (selectedOption) => {
        const tipo = selectedOption ? selectedOption.value : "";
        setFormData((prevData) => ({
            ...prevData,
            tipoVisita: tipo,
            visita_fuera_santiago: tipo === 1 ? (prevData.visita_fuera_santiago || '0') : '',
        }));
    };

    const handleSelectChange = (fieldName) => (selectedOption) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: selectedOption ? selectedOption.value : '',
            ...(fieldName === 'tipoVisita' && {
                visita_fuera_santiago: selectedOption && selectedOption.value === 1 ? (prevData.visita_fuera_santiago || 'no') : '',
            }),
        }));
    };

    const handleSeleccionPaciente = (paciente) => {
        setPacienteInfo(paciente); // Guardamos los detalles completos del paciente
        setFormData((prevData) => ({
            ...prevData,
            ...paciente.visita,
            pacienteID: paciente.id ? paciente.id : "",
            diagnostico: paciente.diagnostico,
            visitaID: (id && id != undefined) ? paciente.visita.visitaID || 0 : 0,
        }));

        setAuxiliares(paciente.auxiliares.map(auxiliar => ({
            value: auxiliar.id,
            label: `${auxiliar.nombre} ${auxiliar.apellidoPaterno} ${auxiliar.apellidoMaterno} (${auxiliar.rut})`
        })));
    };

    const handleAuxiliar = (selectedOption) => {
        console.log(selectedOption)
        setAuxiliarOption(selectedOption);
        setAuxiliarInfo({ auxiliarID: selectedOption ? selectedOption.value : "", nombre: selectedOption ? selectedOption.label : "" });
    };

    const handleAddObservacion = () => {
        if (auxiliarInfo) {
            if (formData.observaciones == '') {
                gdAlertify.notiError("Debe escribir observación.");
                return;
            }
            setObservacionesList((prevList) => [
                ...prevList,
                { auxiliarID: auxiliarInfo.auxiliarID, nombre_auxiliar: auxiliarInfo.nombre, observacion: formData.observaciones },
            ]);
        } else {
            gdAlertify.notiError("Debe seleccionar un auxiliar primero.");
        }
    };

    const handleDeleteObservacion = (index) => {
        const newList = [...observacionesList];
        newList.splice(index, 1); // Eliminar observación en el índice seleccionado
        setObservacionesList(newList);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (formData.tipoVisita == '') {
            gdAlertify.alertError('Falta Tipo de visita');
            return;
        }

        gdAlertify.confirm({
            title: 'Confirmar Ingreso',
            message: `¿Está seguro de guardar el ingreso para el dia ${formatFechaES(formData.fechaVisita)}?`,
            onConfirm: async () => {
                try {
                    gdAlertify.showLoader();
                    axiosInstance.post('/paciente/visita/registro', { visita: formData, observaciones: observacionesList })
                        .then((response) => {
                            if (!response.data.error) {
                                gdAlertify.alertSuccess(response.data.message);
                            } else {
                                gdAlertify.alertError(response.data.message);
                            }
                        })
                        .catch((error) => {
                            gdAlertify.notiError(error)
                            console.error(error);
                        });
                    gdAlertify.hideLoader();
                } catch (error) {
                    gdAlertify.hideLoader();
                    gdAlertify.notiError("Ocurrió un error al conectar con el servidor.");
                }
            },
            onCancel: () => {
                gdAlertify.notify('Envío cancelado', 'error');
            }
        });
    };

    return (
        <div className="container mt-4">
            <div className="card">
                <div className="card-header">
                    <h3>Formulario de Visita</h3>
                </div>
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <fieldset>
                            <div className="mb-3">
                                <BuscarPaciente
                                    onSelect={handleSeleccionPaciente}
                                    conAuxiliares={true}
                                    conVisita={true}
                                />
                            </div>

                            <div className="mb-3">
                                {pacienteInfo ? (
                                    <div>
                                        <strong>Paciente Seleccionado:</strong> {pacienteInfo.nombres} {pacienteInfo.apellidoPaterno} {pacienteInfo.apellidoMaterno}<br />
                                        <strong>Edad:</strong> {calculateAge(pacienteInfo.fechaNacimiento)} Años
                                    </div>
                                ) : (
                                    <p>No se ha seleccionado un paciente.</p>
                                )}
                            </div>

                            {[
                                { name: "fechaVisita", label: "Fecha de Visita", required: true, type: "date" },
                                { name: "tipoVisita", label: "Tipo de Visita", required: false, type: "select", options: tipoVisita },
                            ].map((field) => (
                                <div className="mb-3" key={field.name}>
                                    <label htmlFor={field.name} className="form-label">{field.label}</label>
                                    {field.type === "textarea" ? (
                                        <textarea
                                            id={field.name}
                                            name={field.name}
                                            value={formData[field.name]}
                                            onChange={handleChange}
                                            className="form-control"
                                            required={field.required}
                                        />
                                    ) : (field.type === "select" ? (
                                        <Select
                                            options={field.options}
                                            value={field.options.find(opt => opt.value === formData[field.name])}
                                            onChange={handleSelect}
                                            placeholder="Seleccione"
                                            isClearable
                                        />
                                    ) : (
                                        <input
                                            type={field.type || "text"}
                                            id={field.name}
                                            name={field.name}
                                            value={formData[field.name]}
                                            onChange={handleChange}
                                            className="form-control"
                                            required={field.required}
                                        />)
                                    )}
                                </div>
                            ))}

                            {/* Campo condicional después de tipoVisita */}
                            {/*formData.tipoVisita === 1 && (
                                <div className="mb-3">
                                    <label className="form-label">¿Visita fuera de Santiago?</label>
                                    <Select
                                        name="visita_fuera_santiago"
                                        options={[{value: 1, label: "Si"},{value: 0, label: "No"}]}
                                        value={[{value: 1, label: "Si"},{value: 2, label: "No"}].find(opt => opt.value === formData['visita_fuera_santiago'])}
                                        onChange={handleSelectChange('visita_fuera_santiago')}
                                        placeholder="Seleccione"
                                        isClearable
                                    />
                                </div>
                            )*/}

                            {/* Continúa con el resto del map */}
                            {[
                                { name: "diagnostico", label: "Diagnóstico", required: false, type: "textarea" },
                                { name: "estado_salud", label: "Estado de salud", required: false, type: "textarea" },
                                { name: "estado_cognitivo", label: "Estado cognitivo", required: false, type: "textarea" },
                                { name: "habla", label: "Lenguaje", required: false, type: "textarea" },
                                { name: "movimiento", label: "Movilidad", required: false, type: "textarea" },
                                { name: "antecedentes_medicos", label: "Antecedentes medicos", required: false, type: "textarea" },
                                { name: "examen_fisico", label: "Evolución", required: false, type: "textarea" },
                                { name: "medicamento_horarios", label: "Medicamentos y horario", required: false, type: "textarea" },
                                { name: "rutina", label: "Rutinas y/o actividades del paciente", required: false, type: "textarea" },
                                { name: "plan_atencion", label: "Plan de atencion", required: false, type: "textarea" },
                                { name: "observaciones_paciente", label: "Observacion paciente", required: false, type: "textarea" },
                            ].map((field) => (
                                <div className="mb-3" key={field.name}>
                                    <label htmlFor={field.name} className="form-label">{field.label}</label>
                                    {field.type === "textarea" ? (
                                        <textarea
                                            id={field.name}
                                            name={field.name}
                                            value={formData[field.name]}
                                            onChange={handleChange}
                                            className="form-control"
                                            required={field.required}
                                        />
                                    ) : (field.type === "select" ? (
                                        <Select
                                            options={field.options}
                                            value={auxiliares.find(options => options.id === formData[field.name])}
                                            onChange={handleSelect}
                                            placeholder="Seleccione"
                                            isClearable
                                        />
                                    ) : (
                                        <input
                                            type={field.type || "text"}
                                            id={field.name}
                                            name={field.name}
                                            value={formData[field.name]}
                                            onChange={handleChange}
                                            className="form-control"
                                            required={field.required}
                                        />)
                                    )}
                                </div>
                            ))}


                            <div className="mb-3">
                                <label className="form-label">Auxiliar</label>
                                <Select
                                    options={auxiliares}
                                    value={auxiliarOption}
                                    onChange={handleAuxiliar}
                                    placeholder="Seleccione un auxiliar"
                                    isClearable
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="observaciones" className="form-label">Observaciones</label>
                                <textarea
                                    id="observaciones"
                                    name="observaciones"
                                    value={formData.observaciones}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                                <button
                                    type="button"
                                    className="btn btn-primary mt-2"
                                    onClick={handleAddObservacion}
                                >
                                    Agregar Observación
                                </button>
                            </div>

                            <div className="mt-3">
                                <h5>Observaciones:</h5>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Auxiliar</th>
                                            <th>Observación</th>
                                            <th>Eliminar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {observacionesList.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.nombre_auxiliar}</td>
                                                <td>{item.observacion}</td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleDeleteObservacion(index)}
                                                    >
                                                        Eliminar
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>


                            <div className="text-center mt-3">
                                <button type="submit" className="btn btn-success">Guardar</button>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default FormVisita;
